var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQuestionnaire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BoxContent/Header/LeftIcon15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon15",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon",
    fill: "#F5F5F7",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12,4 C13.3062521,4 14.4175144,4.8348501 14.8293257,6.00008893 L16,6 C18.209139,6 20,7.790861 20,10 L20,16 C20,18.209139 18.209139,20 16,20 L10,20 C7.790861,20 6,18.209139 6,16 L6,8 C6,5.790861 7.790861,4 10,4 L12,4 Z M16,8 L10,8 C8.9456382,8 8.08183488,8.81587779 8.00548574,9.85073766 L8,10 L8,16 C8,17.0543618 8.81587779,17.9181651 9.85073766,17.9945143 L10,18 L16,18 C17.0543618,18 17.9181651,17.1841222 17.9945143,16.1492623 L18,16 L18,10 C18,8.8954305 17.1045695,8 16,8 Z M5,15 L5,17 L4,17 C3.44771525,17 3,16.5522847 3,16 C3,15.4477153 3.44771525,15 4,15 L5,15 Z M5,12 L5,14 L4,14 C3.44771525,14 3,13.5522847 3,13 C3,12.4477153 3.44771525,12 4,12 L5,12 Z M5,9 L5,11 L4,11 C3.44771525,11 3,10.5522847 3,10 C3,9.44771525 3.44771525,9 4,9 L5,9 Z",
    id: "Combined-Shape",
    fill: "#181E34",
    opacity: 0.400000006
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,6 C13.5522847,6 14,6.44771525 14,7 L14,13 C14,13.5522847 13.5522847,14 13,14 C12.4477153,14 12,13.5522847 12,13 L12,7 C12,6.44771525 12.4477153,6 13,6 Z",
    id: "Rectangle",
    fill: "#181E34",
    opacity: 0.400000006,
    transform: "translate(13.000000, 10.000000) rotate(-270.000000) translate(-13.000000, -10.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,9 C13.5522847,9 14,9.44771525 14,10 L14,16 C14,16.5522847 13.5522847,17 13,17 C12.4477153,17 12,16.5522847 12,16 L12,10 C12,9.44771525 12.4477153,9 13,9 Z",
    id: "Rectangle",
    fill: "#181E34",
    opacity: 0.400000006,
    transform: "translate(13.000000, 13.000000) rotate(-270.000000) translate(-13.000000, -13.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,12 C13.5522847,12 14,12.4477153 14,13 L14,19 C14,19.5522847 13.5522847,20 13,20 C12.4477153,20 12,19.5522847 12,19 L12,13 C12,12.4477153 12.4477153,12 13,12 Z",
    id: "Rectangle",
    fill: "#181E34",
    opacity: 0.400000006,
    transform: "translate(13.000000, 16.000000) rotate(-270.000000) translate(-13.000000, -16.000000) "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionnaire);
export default __webpack_public_path__ + "static/media/icon-questionnaire.82efbb910989586c197379dd59604d0a.svg";
export { ForwardRef as ReactComponent };